import { Space as AntdSpace } from 'antd';
import { createGuardedComponent } from '../../provider/create-guarded-component';

export type { SpaceProps } from 'antd';

export const Space = createGuardedComponent(AntdSpace) as typeof AntdSpace;
